<div class="logout-page">
  @if (confirming()) {
    <div class="logout-prompt">
      <h1>{{ 'LOGOUT.Title' | translate }}</h1>
      <p id="warning">{{ 'LOGOUT.Warning' | translate }}</p>
      <div class="logout-actions">
        <button id="cancel"
          type="button"
          (click)="cancel()">{{ 'LOGOUT.KeepSignedIn' | translate }}</button>
        <button id="confirm"
          type="button"
          (click)="confirm()">{{ 'LOGOUT.Confirm' | translate }}</button>
      </div>
    </div>
  }
</div>
